import { Component, OnInit } from '@angular/core';
import { ReportsService } from 'src/app/_services/reports.service';

@Component({
  selector: 'app-invoice-shipping-address',
  templateUrl: './invoice-shipping-address.component.html',
  styleUrls: ['./invoice-shipping-address.component.scss']
})
export class InvoiceShippingAddressComponent implements OnInit {
item:any=null
  constructor(
    public _reportService: ReportsService,
  ) { }

  ngOnInit(): void {
    this.item = this._reportService.selectedInvoiceDetails.invoiceShipping[0]
  }

}
